// src/sections/Section10.jsx
import React, { useState, useEffect } from "react";
import GoogleMaps from "../components/GoogleMaps";

const Section10 = ({ contenuti, pvList }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredMarkers, setFilteredMarkers] = useState([]);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [showList, setShowList] = useState(true);

  // Centro di default su Bari
  const defaultCenter = { lat: 41.125, lng: 16.87 };
  const [center, setCenter] = useState(defaultCenter);

  // 1) Inizializzo marcatori & centro, e ordino per città
  useEffect(() => {
    const sorted = [...pvList].sort((a, b) =>
      a.city.localeCompare(b.city, undefined, { sensitivity: 'base' })
    );
    setFilteredMarkers(sorted);
    setCenter(defaultCenter);
  }, [pvList]);

  // 2) Rileva se sono in mobile (<992px)
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 992);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // 3) Filtra i marker quando searchTerm ≥ 2, altrimenti ripristina tutta la lista
  useEffect(() => {
    if (searchTerm.length < 2) {
      // Ripristina la lista ordinata iniziale
      const sorted = [...pvList].sort((a, b) =>
        a.city.localeCompare(b.city, undefined, { sensitivity: 'base' })
      );
      setFilteredMarkers(sorted);
      setSelectedItem(null);
      setSelectedMarker(null);
      setCenter(defaultCenter);
      return;
    }

    const term = searchTerm.toLowerCase();
    const matches = pvList.filter(
      ({ city, name, postalCode, address }) =>
        city.toLowerCase().startsWith(term) ||
        name.toLowerCase().startsWith(term) ||
        postalCode.startsWith(term) ||
        address.toLowerCase().startsWith(term)
    );

    // Ordina anche le corrispondenze
    const sortedMatches = matches.sort((a, b) =>
      a.city.localeCompare(b.city, undefined, { sensitivity: 'base' })
    );
    setFilteredMarkers(sortedMatches);
    setSelectedItem(null);
    setSelectedMarker(null);
    setCenter(defaultCenter);
  }, [searchTerm, pvList]);

  // Handle input di ricerca
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    if (isMobile) setShowList(true);
  };

  // Quando seleziono un marker dalla lista
  const handleMarkerSelect = (marker, idx) => {
    setSelectedItem(idx);
    setSelectedMarker(marker);
    setCenter(marker.position);
    if (isMobile) setShowList(false);
  };

  // Apri navigatore su mobile
  const apriNavigatore = (lat, lng) => {
    const ua = navigator.userAgent || "";
    const urlGmaps = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
    const intentAndroid = `google.navigation:q=${lat},${lng}`;
    const appleMaps = `maps://?daddr=${lat},${lng}`;

    if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
      window.location.href = appleMaps;
    } else if (/Android/.test(ua)) {
      window.location.href = intentAndroid;
      setTimeout(() => window.location.href = urlGmaps, 1000);
    } else {
      window.open(urlGmaps, "_blank");
    }
  };

  useEffect(() => {
  if (selectedItem !== null) {
    const el = document.querySelector(`[data-idx="${selectedItem}"]`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }
}, [selectedItem]);

  return (
    <div
      id="puntiVendita"
      className="container-fluid d-flex flex-column align-items-center"
      style={{ padding: "76px 16px", gap: "16px" }}
    >
      {/* …Titoli da contenuti… */}
      {contenuti.map((c, i) => (
        <div key={i} className="container d-flex flex-column">
          {/* Qui puoi inserire h1/h2 ecc */}
        </div>
      ))}

      <div
        className="row container"
        style={{
          backgroundColor: "var(--off-white)",
          paddingBottom: "76px",
          minHeight: "400px",
        }}
      >
        {/* Colonna lista */}
        <div className="col-12 col-md-6 position-relative">
          <h2 className="title-section-punti-vendita mt-4">Punti Vendita</h2>

          <input
            type="text"
            className="form-control mb-2"
            placeholder="Cerca per nome, città, CAP o indirizzo"
            value={searchTerm}
            onChange={handleSearchChange}
          />

          {isMobile && (
            <button
              className="btn btn-sm btn-outline-secondary mb-2"
              onClick={() => setShowList(v => !v)}
            >
              {showList ? "Nascondi lista" : "Mostra lista"}
            </button>
          )}

          {showList && (
            <ul
              className="list-group text-capitalize w-100"
              style={{ maxHeight: "300px", overflowY: "auto" }}
            >
              {filteredMarkers.length > 0 ? (
                filteredMarkers.map((m, idx) => (
                  <li
                    key={idx}
                    data-idx={idx}   
                    className={`list-group-item ${
                      selectedItem === idx ? "bg-primary text-white" : ""
                    }`}
                    onClick={() => handleMarkerSelect(m, idx)}
                    style={{ cursor: "pointer" }}
                  >
                    {m.city.toUpperCase()} – {m.address.toUpperCase() }  – {m.name.toUpperCase()}
                  </li>
                ))
              ) : (
                <li className="list-group-item text-center">
                  Nessun punto trovato
                </li>
              )}
            </ul>
          )}

          {selectedMarker && (
            <div className="mt-3">
              <p className="title-section-punti-vendita text-capitalize">
                {selectedMarker.name}
              </p>
              <div
                dangerouslySetInnerHTML={{ __html: selectedMarker.orari }}
              />
              {isMobile && selectedMarker.position && (
                <button
                  className="btn w-100 btn-success mt-2 mb-2"
                  onClick={() =>
                    apriNavigatore(
                      selectedMarker.position.lat,
                      selectedMarker.position.lng
                    )
                  }
                >
                  Vai al punto vendita
                </button>
              )}
              <a
                href={`/offerte?city=${encodeURIComponent(
                  selectedMarker.city
                )}&pvCode=${encodeURIComponent(selectedMarker.codice)}`}
                className="btn btn-primary mt-2 mb-3"
              >
                Scopri le offerte
              </a>
            </div>
          )}
        </div>

        {/* Colonna mappa */}
        <div
          style={{ minHeight: "300px" }}
          className="col-12 col-md-6"
          id="mappaPv"
        >
          <GoogleMaps
            center={center}
            zoom={selectedMarker ? 16 : 12}
            markers={filteredMarkers}
            selectedMarker={selectedMarker}
            onMarkerClick={handleMarkerSelect}
          />
        </div>
      </div>
    </div>
  );
};

export default Section10;
